import { fetch } from './fetch'
import api from './url'

export default {
    // 套餐管理
    PackageCreate: function(params) {
        return fetch({
            url: api.PackageCreate,
            method: 'post',
            data: params
        })
    },
    PackageUpdate: function(params) {
        return fetch({
            url: api.PackageUpdate,
            method: 'post',
            data: params
        })
    },
    PackageUpdatePrice: function(params) {
        return fetch({
            url: api.PackageUpdatePrice,
            method: 'post',
            data: params
        })
    },
    PackageList: function(params) {
        return fetch({
            url: api.PackageList,
            method: 'get',
            params: params
        })
    },
    PackageStatus: function(params) {
        return fetch({
            url: api.PackageStatus,
            method: 'post',
            data: params
        })
    },
    PackageChangeStatus: function(params) {
        return fetch({
            url: api.PackageChangeStatus,
            method: 'post',
            data: params
        })
    },
    PackDelete: function(params) {
        return fetch({
            url: api.PackDelete,
            method: 'post',
            data: params
        })
    },
    PackageDetail: function(params) {
        return fetch({
            url: api.PackageDetail,
            method: 'get',
            params: params
        })
    },
    // 套餐折扣
    PackSaleUpdate: function(params) {
        return fetch({
            url: api.PackSaleUpdate,
            method: 'post',
            data: params
        })
    },
    PackSaleList: function(params) {
        return fetch({
            url: api.PackSaleList,
            method: 'get',
            params: params
        })
    },
    PackSaleDelete: function(params) {
        return fetch({
            url: api.PackSaleDelete,
            method: 'post',
            data: params
        })
    },
    PackSaleDetail: function(params) {
        return fetch({
            url: api.PackSaleDetail,
            method: 'get',
            params: params
        })
    },
    // 产品套餐分配
    ProPackDistriUpdate: function(params) {
        return fetch({
            url: api.ProPackDistriUpdate,
            method: 'post',
            data: params
        })
    },
    ProPackDistriList: function(params) {
        return fetch({
            url: api.ProPackDistriList,
            method: 'get',
            params: params
        })
    },
    ProPackDistriListNew: function(params) {
        return fetch({
            url: api.ProPackDistriListNew,
            method: 'get',
            params: params
        })
    },
    ProPackDistriDelete: function(params) {
        return fetch({
            url: api.ProPackDistriDelete,
            method: 'post',
            data: params
        })
    },
    // 规则套餐分配
    RulePackDistriList: function(params) {
        return fetch({
            url: api.RulePackDistriList,
            method: 'get',
            params: params
        })
    },
    RulePackDistriCreate: function(params) {
        return fetch({
            url: api.RulePackDistriCreate,
            method: 'post',
            data: params,
            headers: {
                region: params.region
            }
        })
    },
    RulePackDistriDelete: function(params) {
        return fetch({
            url: api.RulePackDistriDelete,
            method: 'post',
            data: params,
            headers: {
                region: params.region
            }
        })
    },
    // 区域配置
    ReginUpdate: function(params) {
        return fetch({
            url: api.ReginUpdate,
            method: 'post',
            data: params
        })
    },
    ReginList: function(params) {
        return fetch({
            url: api.ReginList,
            method: 'get',
            params: params
        })
    },
    ReginDelete: function(params) {
        return fetch({
            url: api.ReginDelete,
            method: 'post',
            data: params
        })
    },
    ReginDetail: function(params) {
        return fetch({
            url: api.ReginDetail,
            method: 'get',
            params: params
        })
    },
    // 套餐功能组
    PackFuncList: function(params) {
        return fetch({
            url: api.PackFuncList,
            method: 'get',
            params: params
        })
    },
    CouponList: function(params) {
        return fetch({
            url: api.CouponList,
            method: 'get',
            params: params
        })
    },
    CouponCreate: function(params) {
        return fetch({
            url: api.CouponCreate,
            method: 'post',
            data: params
        })
    },
    // 4G套餐管理
    FourGPackageCreate: function(params) {
        return fetch({
            url: api.FourGPackageCreate,
            method: 'post',
            data: params
        })
    },
    FourGPackageUpdateRegion: function(params) {
        return fetch({
            url: api.FourGPackageUpdateRegion,
            method: 'put',
            data: params
        })
    },
    FourGPackageUpdatePrice: function(params) {
        return fetch({
            url: api.FourGPackageUpdatePrice,
            method: 'put',
            data: params
        })
    },
    FourGPackageList: function(params) {
        return fetch({
            url: api.FourGPackageList,
            method: 'get',
            params: params
        })
    },
    FourGPackageDetail: function(params) {
        return fetch({
            url: api.FourGPackageDetail,
            method: 'get',
            params: params
        })
    },
    FourGPackageUpdateStatus: function(params) {
        return fetch({
            url: api.FourGPackageUpdateStatus,
            method: 'put',
            data: params
        })
    },
    // Alarm套餐管理
    AlarmPackageCreate: function(params) {
        return fetch({
            url: api.AlarmPackageCreate,
            method: 'post',
            data: params
        })
    },
    AlarmPackageUpdateRegion: function(params) {
        return fetch({
            url: api.AlarmPackageUpdateRegion,
            method: 'post',
            data: params
        })
    },
    AlarmPackageUpdatePrice: function(params) {
        return fetch({
            url: api.AlarmPackageUpdatePrice,
            method: 'post',
            data: params
        })
    },
    AlarmPackageList: function(params) {
        return fetch({
            url: api.AlarmPackageList,
            method: 'get',
            params: params
        })
    },
    AlarmPackageDetail: function(params) {
        return fetch({
            url: api.AlarmPackageDetail,
            method: 'get',
            params: params
        })
    },
    AlarmPackageUpdateStatus: function(params) {
        return fetch({
            url: api.AlarmPackageUpdateStatus,
            method: 'post',
            data: params
        })
    },
    PackageLevelList: function(params) {
        return fetch({
            url: api.PackageLevelList,
            method: 'get',
            params: params
        })
    }
}
